/* ZUCK 2026-10-30 — Black VS VIP prices runtime (snippets/bfvs-head.liquid + skill rna-versiani-bf-vip-hour).
   Flagged visitors only: make sure the cart carries the attribute `_bfvs` (the VS Toolkit "Black VS" automatic
   discount only prices carts with it), then refresh the cart drawer. `?bfvs=0` removes the attribute again.
   2026-10-31 (Nicolas): the Black VS gifts follow the same flag. Gifter offers limited to the link /pages/black-vs
   only discount a gift when their offerId is in the cart attribute `_gifter_links`, which Gifter itself writes only
   on a visit to that page while an offer is running, and only into that cart. So a flagged visitor also gets those
   offerIds (read from Gifter's own #gifter-data, never hardcoded) on every page and every new cart; `?bfvs=0`
   removes them. Other link offers' ids are left alone. */
(function () {
  var BF = window.BFVS;
  if (!BF || (!BF.vip() && !BF.off)) return;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var PAGE = BF.page || '/pages/black-vs';
  var LINKS = '_gifter_links';
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function gifterIds() {
    try {
      var d = JSON.parse(document.getElementById('gifter-data').textContent);
      return (d.offers || [])
        .filter(function (o) { return o.link && o.link.path === PAGE && !Object.keys(o.link.params || {}).length; })
        .map(function (o) { return o.offerId; });
    } catch (e) { return []; }
  }
  fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var a = cart.attributes || {};
      var want = BF.vip();
      var attrs = {}, changed = false;
      // 2026-11-01 (Nicolas, after the 09:00 public start): the whole site has the Black prices and the link-only
      // "Black VS" discount is expired, so `_bfvs` is never written any more (it cost one cart/update.js per visitor).
      // `?bfvs=0` still removes a stale `_bfvs` from an older cart.
      if (BF.off && a[BF.attr]) { attrs[BF.attr] = ''; changed = true; }
      var ids = gifterIds();
      if (ids.length) {
        var cur = String(a[LINKS] || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
        var next = cur.filter(function (x) { return ids.indexOf(x) < 0; });
        if (want) next = next.concat(ids);
        if (next.join(',') !== cur.join(',')) { attrs[LINKS] = next.join(','); changed = true; }
      }
      return changed ? post('cart/update.js', { attributes: attrs }) : null;
    })
    .then(function (state) {
      if (state && typeof publish === 'function') {
        try { publish('cart-update', { source: 'bfvs', cartData: state }); } catch (e) {}
      }
    })
    .catch(function () {});
})();
